const PortfolioSmallCards = [
    {
        id: 936,
        layout: "small",
        project_name: "Sistema-Juridico API",
        project_url: "",
        project_git_url: "https://github.com/Valdoveste/Sistema-JuridicoWebApi",
        project_img_alt: "Sistema-Juridico Restful API - Project Image",
        project_desc: "API da aplicação Sistema Jurídico.",
        project_tech: [".NET", "C#"],
        animation_delay: {
            animationDelay: "350ms"
        }
    },
    {
        id: 289,
        layout: "small",
        project_name: "Minecraft Plugins",
        project_url: "",
        project_git_url: "https://github.com/orgs/PracaCraft-Plugins/repositories",
        project_img_alt: "",
        project_desc: "Três pequenos projetos utilizando java onde o foi intuito de relembrar alguns conceitos de Java e entender o processo de desenvolvimento de plugins para servidores do jogo Minecraft. Um dos conhecimentos essências para a finalização da primeira versão desses projetos foi a interação com eventos, criação de tasks/thread, Wrappers, criação e manipulação de arquivos com Java File e Consumo de API.",
        project_tech: ["JAVA", "SPIGOT", "MINECRAFT PLUGIN", "API", "JAVA  FILE"],
        animation_delay: {
            animationDelay: "450ms"
        }
    },
    {
        id: 586,
        layout: "small",
        project_name: "RotmgTargetCreator",
        project_url: "https://valdoveste.github.io/rotmgex-target-creator/",
        project_git_url: "https://github.com/Valdoveste/rotmgex-target-creator",
        project_img_alt: "RotmgTargetCreator Project Image",
        project_desc: "Facilitator for those that have mules and have no patience to create write target in base64.",
        project_tech: ["HTML5", "CSS3", "JS"],
        animation_delay: {
            animationDelay: "550ms"
        }
    },
    {
        id: 471,
        layout: "small",
        project_name: "BatatinhasHardware",
        project_url: "https://batatinha-s-hardware.github.io/batatinhas-hardware/",
        project_git_url: "https://github.com/Batatinha-s-Hardware/batatinhas-hardware",
        project_img_alt: "BatatinhasHardware Project Image",
        project_desc: "Batatinha Hardware, é uma loja virtual fictícia especializada no mercado eletrônico, vendemos aparelhos e acessórios de diversas marcas, sempre buscando entregar omelhor para nosso cliente.",
        project_tech: ["HTML5", "CSS3", "JS", "JQUERY"],
        animation_delay: {
            animationDelay: "650ms"
        }
    }
];


export default PortfolioSmallCards;
